<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="from_date.value.value"
                        label="From Date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        bg-color="grey-lighten-4"
                        autocomplete="off"
                        hide-details
                      />
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="to_date.value.value"
                        label="To Date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        bg-color="grey-lighten-4"
                        autocomplete="off"
                        hide-details
                      />
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Employee"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="employee_id.value.value"
                        :items="getHrmEmployeeList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="employee_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Employee KPI Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="px-2 pt-4 pb-0">
                  <v-col md="3" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                </v-row>

                <v-row class="mb-4">
                  <v-col cols="12" >
                    <v-card style="display: flex; justify-content: center;">
                      <v-card-title>
                        <v-icon class="me-1" size="small">mdi-account</v-icon>
                        {{ getSchema?.name }}
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="getSchema?.kpis"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.color="{ item }">
                    <v-avatar 
                      :style="`background-color: ${item.color};`" 
                      size="24"
                    ></v-avatar>
                  </template>

                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "100px", sortable: false },
      { title: "Name", key: "kpi_name", align: "left", sortable: false, width: "350px" },
      { title: "Weight", key: "weight", align: "right", sortable: false },
      { title: "Color", key: "color", align: "center", sortable: false },
      { title: "Score", key: "score", align: "center", sortable: false },
    ],
  }),
  watch: {},
  created() {

    const promises = [];

    // if (this.$store.getters.getHrmEmployeeList.length == 0) {
      promises.push(this.$store.dispatch("getHrmEmployeeList"));
    // }
    
  },
  computed: {
    getSchema() {
      return this.$store.getters.getHrmEmployeeKpiReport?.[0];
    },
    getHrmEmployeeList() {
      let data = this.$store.getters.getHrmEmployeeList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // Add validation if needed
        employee_id: yup.string().required().label('Employee'),
        // category: yup.number().positive().integer().nullable().label('Category'),
        // sub_category: yup.number().positive().integer().nullable().label('Sub Category'),
      }),
    });

    const employee_id = useField("employee_id");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const type = useField("type");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();

    const submit = handleSubmit((values) => {
      loading.value = true;
      values.type = "employee";
      store
        .dispatch("getHrmEmployeeKpiReport", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response.data.message);
        });
    });

    return {
      from_date,
      to_date,
      employee_id,
      type,
      submit,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$store.commit("setEditingProduct", item);
      this.$router.push({ name: "add-product", query: {id: item.id} });
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Code", "Name", "Brand", "Category", "Sub Category", "Type", "Size", "Unit", "Model", "Purchase Rate", "Sale Rate", "Tax", "Weight", "Status", ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.name, item.brand?.name, item.category?.name, item.subcategory?.name, item.type?.name, item.size?.name, item.unit?.name, item.model, item.purchase_rate, item.sale_rate, item.tax, item.weight, item.status == 1 ? "Active" : "Inactive", ]);
      this.$exportTableToPDF( columns, rows, "Product List", "product_list_" + this.$fileDate() );
    },
    exportToExcel() {
      var data = [[ "#SL", "Code", "Name", "Brand", "Category", "Sub Category", "Type", "Size", "Unit", "Model", "Purchase Rate", "Sale Rate", "Tax", "Weight", "Status", ], ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.name, item.brand?.name, item.category?.name, item.subcategory?.name, item.type?.name, item.size?.name, item.unit?.name, item.model, item.purchase_rate, item.sale_rate, item.tax, item.weight, item.status == 1 ? "Active" : "Inactive", ]);
      });
      this.$exportTableToExcel(data, "product_list_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [[ "#SL", "Code", "Name", "Brand", "Category", "Sub Category", "Type", "Size", "Unit", "Model", "Purchase Rate", "Sale Rate", "Tax", "Weight", "Status", ]];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.name, item.code, item.brand?.name, item.category?.name, item.subcategory?.name, item.type?.name, item.size?.name, item.unit?.name, item.model, item.purchase_rate, item.sale_rate, item.tax, item.weight, item.status == 1 ? "Active" : "Inactive", ]);
      });

      this.$exportTableToCSV(data, "product_list_" + this.$fileDate());
    },
  },
  mounted() {
    // Auto-trigger search on mount like the requisition list
    // this.$nextTick(() => {
    //   this.$refs.searchButton.$el.click();
    // });   
  },
};
</script>
